import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RendezVousV3Component } from './rendez-vous.component';
import { DynamicTagAddonModule, BodisplayModule } from '../../bodisplay';
import { AutoSearchModule } from '../../autosearch';
import { PipeModule } from '../../pipes';


@NgModule({
  declarations: [
    RendezVousV3Component
  ],
  exports: [
    RendezVousV3Component
  ],
  imports: [
    FormsModule,
    CommonModule,
    BodisplayModule,
    DynamicTagAddonModule,
    NgbModule,
    AutoSearchModule,
    PipeModule
  ]
})
export class RendezVousV3Module { }
